(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dwan-original-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dwan-home-carousel')) {
    customElements.define('dwan-home-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this._homeCleanup) return;
        const slides = Array.from(this.querySelectorAll('[data-home-slide]'));
        const controls = this.querySelector('[data-home-controls]');
        const status = this.querySelector('[data-home-status]');
        if (slides.length < 2 || !controls || !status) return;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let current = Math.max(0, slides.findIndex((slide) => !slide.hidden));
        let timer = null;
        let animations = [];
        let transitionId = 0;
        let hovered = window.matchMedia('(hover: hover)').matches && this.matches(':hover');
        let focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
        const stopTimer = () => {
          if (timer !== null) window.clearTimeout(timer);
          timer = null;
          this.dataset.autoplayRunning = 'false';
        };
        const settle = () => {
          transitionId += 1;
          animations.forEach((animation) => animation.cancel());
          animations = [];
          slides.forEach((slide, index) => {
            slide.hidden = index !== current;
            slide.inert = index !== current;
            slide.setAttribute('aria-hidden', String(index !== current));
            slide.classList.remove('dwan-home-carousel__leaving');
          });
        };
        const showSlide = (target, animate = true) => {
          const previous = current;
          settle();
          current = target;
          this.dataset.activeSlide = String(current);
          this.dataset.activePoster = String(slides[current].classList.contains('dwan-home-carousel__poster'));
          this.querySelectorAll('[data-home-slide-index]').forEach((element) => {
            element.setAttribute('aria-pressed', String(Number(element.dataset.homeSlideIndex) === current));
          });
          slides[current].hidden = false;
          slides[current].inert = false;
          slides[current].setAttribute('aria-hidden', 'false');
          status.textContent = status.dataset.homeStatusTemplate.replace('__CURRENT__', String(current + 1));
          const upcoming = slides[(current + 1) % slides.length];
          upcoming.querySelectorAll('img').forEach((image) => { image.loading = 'eager'; });
          if (animate && previous !== current && !motion.matches && typeof slides[current].animate === 'function') {
            const outgoing = slides[previous];
            outgoing.hidden = false;
            outgoing.inert = true;
            outgoing.setAttribute('aria-hidden', 'true');
            outgoing.classList.add('dwan-home-carousel__leaving');
            const token = transitionId;
            const options = { duration: 550, easing: 'ease-in-out', fill: 'both' };
            const fadeOut = outgoing.animate([{ opacity: 1 }, { opacity: 0 }], options);
            const fadeIn = slides[current].animate([{ opacity: 0 }, { opacity: 1 }], options);
            animations = [fadeOut, fadeIn];
            Promise.all(animations.map((animation) => animation.finished)).then(() => {
              if (token === transitionId) settle();
            }).catch(() => {});
          } else {
            settle();
          }
        };
        const blocked = () => motion.matches || hovered || focused || document.hidden || !this.isConnected;
        const schedule = () => {
          stopTimer();
          this.dataset.autoplayEnabled = String(!motion.matches);
          status.setAttribute('aria-live', blocked() ? 'polite' : 'off');
          if (blocked()) return;
          timer = window.setTimeout(() => {
            timer = null;
            if (!blocked()) showSlide((current + 1) % slides.length);
            schedule();
          }, 5000);
          this.dataset.autoplayRunning = 'true';
        };
        const onClick = (event) => {
          const button = event.target.closest('[data-home-direction], [data-home-slide-index]');
          if (!button || !this.contains(button)) return;
          const target = button.hasAttribute('data-home-slide-index') ? Number(button.dataset.homeSlideIndex) : (current + Number(button.dataset.homeDirection) + slides.length) % slides.length;
          if (!Number.isInteger(target) || target < 0 || target >= slides.length) return;
          if (target !== current) showSlide(target);
          focused = button.matches(':focus-visible');
          schedule();
        };
        const onPointerEnter = (event) => {
          if (event.pointerType === 'touch') return;
          hovered = true;
          schedule();
        };
        const onPointerLeave = (event) => {
          if (event.pointerType === 'touch') return;
          hovered = false;
          schedule();
        };
        const onFocusIn = (event) => {
          focused = event.target.matches(':focus-visible');
          schedule();
        };
        const onFocusOut = (event) => {
          if (this.contains(event.relatedTarget)) return;
          focused = false;
          schedule();
        };
        const onVisibility = () => schedule();
        const onMotion = () => { settle(); schedule(); };
        const listeners = [
          [this, 'click', onClick],
          [this, 'pointerenter', onPointerEnter],
          [this, 'pointerleave', onPointerLeave],
          [this, 'focusin', onFocusIn],
          [this, 'focusout', onFocusOut],
          [document, 'visibilitychange', onVisibility],
          [motion, 'change', onMotion]
        ];
        listeners.forEach(([target, type, handler]) => target.addEventListener(type, handler));
        this._homeCleanup = () => {
          stopTimer();
          settle();
          listeners.forEach(([target, type, handler]) => target.removeEventListener(type, handler));
          delete this._homeCleanup;
          delete this.dataset.ready;
        };
        this.dataset.ready = 'true';
        controls.hidden = false;
        showSlide(current, false);
        schedule();
      }
      disconnectedCallback() {
        if (this._homeCleanup) this._homeCleanup();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
